import AuthService from "../../services/authentication";
import VueCookies from "vue-cookies";

const admin = VueCookies.get("admin");

const showAnalytics =
  localStorage.getItem("analytics") === "false" ? false : true;

const initialState = {
  showAnalytics
};

export const rnpl = {
  namespaced: true,
  state: initialState,
  actions: {},
  mutations: {
    toggleAnalytics(state, value) {
      state.showAnalytics = value;
      localStorage.setItem("analytics", value);
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/rnpl.module.js